export const CardHeader = ({step, label}: {step: number | string; label: string}) => (
  <div className="flex items-center gap-3 border-b border-grey-150 px-6 py-4">
    <span className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-[6px] bg-green-neon text-12 font-bold text-moss-green-900">
      {step}
    </span>
    <span className="text-18 font-semibold text-moss-black">{label}</span>
  </div>
)
